export default {
  url: 'https://ef682da076ec4f3bbbb5f46780b4ab85@sentry.io/1510374',
};
